export default __webpack_public_path__ + "static/media/analyze.e7fc68ba.svg";